import React from "react";
import { RotatingLines } from "react-loader-spinner";

export const LoadingView = () => {
    return (<>
        {/* <RotatingLines
      strokeColor="#3A52BB"
      strokeWidth="5"
      animationDuration="1.75"
      width="66"
      visible={true}
    /> */}
        <div className="loaderAnimations"></div>
    </>
    );
};

export const ProfilePicLoader = ({ color = "black" }) => {
    return (
        <RotatingLines
            strokeColor={color}
            strokeWidth="5"
            animationDuration="1.75"
            width="20"
            visible={true}
        />
    );
};

export const Loader = ({ color = "white", width = "20" }) => {
    return (
        <RotatingLines
            strokeColor={color}
            strokeWidth="5"
            animationDuration="1.75"
            width={width}
            visible={true}
        />
    );
};

/** Inline loading indicator: blue spinner + text (same as prep check / audit team). Use for Team, Handover, etc. */
export const InlineLoadingIndicator = ({ message = 'Loading...' }) => (
    <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-500 border-t-transparent" aria-hidden />
        <span className="ml-2 text-sm text-gray-600 font-medium">{message}</span>
    </div>
);

/** Full-page fallback for lazy routes (Suspense). Use as fallback={RouteLoadingFallback} or <RouteLoadingFallback /> */
export const RouteLoadingFallback = () => (
    <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" aria-hidden />
            <p className="text-gray-600">Loading...</p>
        </div>
    </div>
);

export const LoadingView2 = ({ message, progressText }) => {
    return (
        <div className="fixed bottom-0 right-4 w-96 bg-white border rounded-t-lg shadow-2xl z-[99] p-4 flex flex-col space-y-2">
            <div className="flex justify-between items-center">
                <input type="text" className="w-full" placeholder="Scan code" />
                <h2 className="text-2xl font-semibold">{progressText}</h2>
                <button className="text-gray-500 hover:text-gray-700">
                    &times;
                </button>
            </div>
            <div className="flex items-center justify-between text-sm text-gray-700">
                <div className="flex items-center gap-2">
                    <span>{message}</span>
                </div>
                <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-gray-500"></div>
            </div>
        </div>
    );
};


